import React, { useEffect, useState } from 'react';


function DateSlider({ id, date, setDate, minDate, maxDate }) {
    const [ sliderMax, setSliderMax ] = useState();
    const [ sliderValue, setSliderValue ] = useState(date.default);

    useEffect(() => {
        let newDate;

        if(id === "minDate") {
            newDate = minDate.minValue.add(sliderValue, "month");
        } else {
            newDate = minDate.value.add(sliderValue, "month");
        } 

        setDate((prev) => ({
            ...prev,
            value: newDate
        }));
    }, [sliderValue])

    useEffect(() => {
        if(id !== "minDate") {
            let newMax;
    
            if(id === "maxDate") {
                newMax = maxDate.maxValue.diff(minDate.value, "month");
                const newValue = date.value.diff(minDate.value, "month");
                
                setSliderValue(newValue);
            } else if(id === "currentDate") {
                newMax = maxDate.value.diff(minDate.value, "month");

                if(date.value < minDate.value) {
                    setDate((prev) => ({
                        ...prev,
                        value: minDate.value
                    }))
                } else {
                    const newValue = date.value.diff(minDate.value, "month");
                    setSliderValue(newValue);
                }
            }
    
            setSliderMax(newMax);
        }

    }, [minDate])

    useEffect(() => {
        if(id !== "maxDate") {
            let newMax;
    
            if(id === "minDate") {
                newMax = maxDate.value.diff(minDate.minValue, "month");
            } else if(id === "currentDate") {
                newMax = maxDate.value.diff(minDate.value, "month");
    
                if (date.value > maxDate.value) {
                    setDate((prev) => ({
                        ...prev,
                        value: maxDate.value
                    }))
                }
            }
    
            setSliderMax(newMax);
        }
    }, [maxDate])



    const onChangeSliderHandle = (event) => {
        const newValue = parseInt(event.target.value);
        setSliderValue(newValue);
    }

    return (
        <div>
            <input id={`${id}Input`} type="range" min={0} max={sliderMax} step="1" value={sliderValue} onChange={onChangeSliderHandle}/>
            <span id={id}>{date.value.format("YYYY-MM")}</span>
        </div>
    );
}

export default DateSlider;
